import { Injectable } from '@angular/core';

import { SelectItem } from 'primeng/api';

@Injectable()
export class UtilsService {
  public cameraId: number;

  constructor() { }

  public static updateList(list: SelectItem[], newItem: SelectItem) {
    const index = list.findIndex(i => i.value === newItem.value);
    if (index === -1) {
      list.push(newItem);
    }
    
    list.sort((a: SelectItem, b: SelectItem) => {
      return a.label < b.label ? 1 : a.label === b.label ? 0 : -1;
    });
  }
}
